import React, { useState } from "react";
import "./SectionTwo.css";
import CustomModal from "./CustomModal";

const SectionTwo = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="checkbox-form-container">
        <h2>Please Check Boxes Where Your Answer is YES!</h2>
        <div className="checkbox-grid">
          {[
            {
              id: 1,
              text: "I want to start a career in",
              bold: "Digital Marketing",
              suffix: "but don’t know where to begin.",
            },
            {
              id: 2,
              text: "I want to earn money online through",
              bold: "freelancing or internships",
              suffix: "while studying.",
            },
            {
              id: 3,
              text: "I want to gain",
              bold: "practical skills in SEO, Social Media & Ads",
              suffix: "that companies look for.",
            },
            {
              id: 4,
              text: "I want to build my",
              bold: "personal brand or Instagram page",
              suffix: "using marketing strategies.",
            },
            {
              id: 5,
              text: "I want to explore",
              bold: "freelance projects",
              suffix: "and side hustles in digital marketing.",
            },
            {
              id: 6,
              text: "I am curious about how",
              bold: "ads, content & social media",
              suffix: "actually grow real businesses.",
            },
          ].map(({ id, text, bold, suffix }) => (
            <div className="checkbox-item" key={id}>
              <input type="checkbox" id={`checkbox${id}`} />
              <label htmlFor={`checkbox${id}`}>
                {text} <strong>{bold}</strong> {suffix}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="textBox">
        <h2>If you marked any of the boxes listed above, then the...</h2>
        <h1 style={{ color: "#ff0099" }}>
          This DIGITAL MARKETING COURSE is designed specifically for you!
        </h1>
      </div>

      <div style={{ textAlign: "center" }}>
        <button className="sectionBtn" onClick={openModal}>
          ENROLL NOW
        </button>
      </div>

     <CustomModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default SectionTwo;
